const FJCutConfig = {
    // 最小宽度缩放比例
    minWidthScale: 1 / 5,
    // 最大宽度缩放比例
    maxWidthScale: (1 / 6) * 30,
};

export default FJCutConfig